import InviteCustomerDialogModule from './InviteCustomerDialog.module';

export * from './InviteCustomerDialogModuleProps';
export default InviteCustomerDialogModule;
